/**
 * Trigger the Cal.com strategy-session popup using the globally-initialised Cal embed
 * (see public/index.html). Falls back to opening cal in a new tab if the embed
 * script hasn't loaded.
 */
export function openStrategySession() {
  try {
    if (typeof window === "undefined") return;
    const cal = window.Cal;
    if (cal && cal.ns && typeof cal.ns["strategy-session"] === "function") {
      cal.ns["strategy-session"]("modal", {
        calLink: "sidsv/strategy-session",
        config: { layout: "month_view" },
      });
      return;
    }
    window.open("https://cal.com/sidsv/strategy-session", "_blank", "noopener,noreferrer");
  } catch {
    window.open("https://cal.com/sidsv/strategy-session", "_blank", "noopener,noreferrer");
  }
}
